import { Component, Injector, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { WidgetSettingsControlBase } from '../control-base';
import { takeUntil } from 'rxjs/operators';
import { FiBrowserEventsService } from '@fi-shared/fi-shared-services/fi-browser-events.service';
import { TextEditorService } from '@fi-shared/fi-text-editor/text-editor.service';
import { Subject } from 'rxjs';
import { ObjectTypes } from '@fi-shared/types';
import { DropdownListSettingsLanguageModel } from '@fi-shared/dropdown';
import { IDropdownSelectLanguageSettingsItem } from '@fi-shared/fi-content-language-shared/fi-content-language-shared';
import { FiReplaceLinkTypes } from '@fi-shared/fi-directives/replace-with-links/replace-with-links.directive';
import { FiUserDataService } from '@fi-shared/fi-shared-services/fi-user-data.service';

interface IAdvancedTextWidgetSettingsContent {
    ContentLanguageId: number;
    Value: string;
}

@Component({
    selector: 'widget-settings-control-advanced-text',
    templateUrl: './advanced-text.component.html',
    styleUrls: ['./advanced-text.component.scss'],
    encapsulation: ViewEncapsulation.None,
    host: { class: 'widget-settings-control-advanced-text' },
    standalone: false,
})
export class WidgetSettingsControlAdvancedTextComponent extends WidgetSettingsControlBase implements OnInit, OnDestroy {
    isCaretVisible = true;
    selectedLanguageId: number;
    dropdownSelectLanguageSettings: DropdownListSettingsLanguageModel<IDropdownSelectLanguageSettingsItem>;
    focusedNodeElement: HTMLElement;
    ObjectTypes = ObjectTypes;
    readonly fiReplaceWithLinks: FiReplaceLinkTypes[] = [FiReplaceLinkTypes.Url, FiReplaceLinkTypes.Email];

    constructor(
        injector: Injector,
        private contentLanguageService: ContentLanguagesService,
        private fiBrowserEventsService: FiBrowserEventsService,
        private textEditorService: TextEditorService,
        private fiUserDataService: FiUserDataService,
    ) {
        super(injector);
        this.dropdownSelectLanguageSettings = this.contentLanguageService.GetDropdownListSettingsLanguage();
        this.selectedLanguageId = this.fiUserDataService.userData.PreferredContentLanguage;
    }

    ngOnInit() {
        this.handleTabKeyPress();
        this.setLanguagesSelectSettings();
    }

    private handleTabKeyPress() {
        this.fiBrowserEventsService
            .getWindowEventSubject$('keydown')
            .pipe(takeUntil(this.ngOnDestroy$))
            .subscribe(($event: KeyboardEvent) => {
                this.textEditorService.handleTabKeyPress($event);
            });
    }

    private setLanguagesSelectSettings() {
        if (!this.Settings) return;

        let existingIds: number[] = [];

        if (!Array.isArray(this.Settings.Contents)) {
            this.Settings.Contents = [];
        } else {
            existingIds = this.Settings.Contents.map((content: IAdvancedTextWidgetSettingsContent) => {
                return content.ContentLanguageId;
            });
        }

        this.dropdownSelectLanguageSettings.dataSet.forEach((item: IDropdownSelectLanguageSettingsItem) => {
            if (existingIds.indexOf(item.Id) === -1) {
                existingIds.push(item.Id);
                this.Settings.Contents.push({
                    ContentLanguageId: item.Id,
                    Value: '',
                });
            }
        });
    }

    isLanguageSelected(id: number): boolean {
        return this.selectedLanguageId === id;
    }

    setCaretVisibility($event: boolean) {
        this.isCaretVisible = $event;
    }

    setFocusedElement() {
        this.focusedNodeElement = this.textEditorService.getFocusedElement();
    }

    onContentChanged() {
        this.setFocusedElement();
        this.settingsPropertyOnChange();
    }

    private ngOnDestroy$ = new Subject<void>();
    ngOnDestroy(): void {
        this.ngOnDestroy$.next();
        this.ngOnDestroy$.complete();
    }
}
